<template>
  <b-modal
    title="حذف درس از کاربر"
    id="remove-lesson-from-user"
    centered
    ok-title="حذف"
    cancel-title="بستن"
    ok-variant="danger"
    @ok.prevent="removeLessonFromUser"
  >
    <b-container fluid>
      <b-form-row>
        <b-col cols="12">
          <p>
            آیا از حذف
            <span class="text-danger">
              {{ lessonTitle }}
            </span>
            از کاربر اطمینان دارید؟
          </p>
        </b-col>
      </b-form-row>
    </b-container>
  </b-modal>
</template>
<script>
export default {
  emits: ["removeLesson"],
  props: {
    lessonTitle: {
      type: [String, null],
    },
  },
  methods: {
    removeLessonFromUser() {
      this.$emit("removeLesson");
    },
  },
  components: {
    BModal,
    BContainer,
    BRow,
    BCol,
    BFormRow,
    BFormGroup,
    BFormInput,
    BFormSelect,
  },
};
import {
  BModal,
  BContainer,
  BRow,
  BCol,
  BFormRow,
  BFormGroup,
  BFormInput,
  BFormSelect,
} from "bootstrap-vue";
</script>
